import { CONTENT_CARD_CLICK, CONTENT_CARD_CLICK_API_ERROR, CONTENT_CARD_CLICK_SUCCESS } from "./ActionTypes";

//Content Card onclick

  export const contentCardOnclick = (name,page) => {
    return {
      type: CONTENT_CARD_CLICK,
      payload: {name,page}
    };
  };

  export const contentCardOnclickSuccess = data => {
    return {
      type: CONTENT_CARD_CLICK_SUCCESS,
      payload: data,
    };
  };
  
  export const contentCardOnclickApiError = error => {
    return {
      type: CONTENT_CARD_CLICK_API_ERROR,
      payload: error,
    };
  };

  